<div class="container-fluid tpl-pdf">
    <div class="row align-items-center">
        <div class="col-3"><img src="assets/img/black-logo.png" alt="logo"></div>
        <div class="col text-small">
CENTRUL MEDICAL DE DIAGNOSTIC, TRATAMENT AMBULATOR SI MEDICINA PREVENTIVA – BUCURESTI<br>
Str. Washington nr. 8-10, Sector 1, Bucuresti<br>
CONT IBAN: RO67 TREZ 7015041XXX000394, Trezoreria sector 1<br>
Tel. 021/230.29.80, Fax 021/318.02.62; CUI: 4283325;<br>
www.cmdtamp.ro; office@cmdtamp.ro<br>
SECTIA RADIOLOGIE SI IMAGISTICA MEDICALA<br>
        </div> 
    </div>
    <div class="row">
        <div class="col text-center">
            <h4>
                RAPORT DE INVESTIGATIE IMAGISTICA NR. 04 DIN DATA 28.03.2024 RADIOGRAFIE
            </h4>
        </div>
    </div>
    <div class="row chenar">
        <div class="col-4">
            <span>NUME: </span>
            <strong>RADCOM</strong>
        </div>
        <div class="col-4">
            <span>PRENUME: </span>
            <strong>RADCOM</strong>
        </div>
        <div class="col-4">
            <span>CNP: </span>
            <strong>2200214016690</strong>
            <span class="px-2">SEX: </span>
            <strong>F</strong>
        </div>
        <div class="col-4">
            <span>VARSTA: </span>
            <strong>104 ANI SI 1 LUNA</strong>
        </div>
        <div class="col-8">
            <span>DOMICILIUL: </span>
            <strong>STR TEST, SECTORUL 1, BUCURESTI</strong>
        </div>
        <div class="col-4">
            <span>TRIMIS DE: </span>
            <strong>RADCOM</strong>
        </div>
        <div class="col-8">
            <span>REGIUNE DE EXAMINAT: </span>
            <strong>TEST RADIOGRAFIE</strong>
        </div>
        <div class="col">
            <span>DIAGNOSTIC CLINIC/COD: </span>
            <strong>LEZIUNI TRAUMATICE ALE TORACELUI, ALTE SI FARA PRECIZARE</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h4>REZULTATUL EXAMINARII:</h4>
            <p>
                TEST RADIOGRAFIE TEST RADIOGRAFIE
                TEST RADIOGRAFIE TEST RADIOGRAFIE
                TEST RADIOGRAFIE TEST RADIOGRAFIE
            </p>
        </div>
        <div class="col-12 text-end mt-3">
            <h5>
                Dr. Admin Administrator
            </h5>
        </div>
    </div>
</div>